import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  mutations,
  getters,
  actions,

  state: {
    countdown: -1,
    seats: null,
    ticketDetail: null,
    holdId: null,
    logID: null,
    selectedShow: null,
    paymentData: {},
    giftCard: {},
    ticketTypeCount: {},
    selectedSeats: [],
    priceGroups: []
  }
};
